import React, { useEffect, useState } from 'react';
import './VideoImg.css';
import db from '../../firebase';
import { collection, doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { getLatestLiveVideo, getEmbedUrl } from '../../api/youtubeApi';

const VideoImg = ({ isLoggedIn }) => {
  const [videoUrl, setVideoUrl] = useState('');
  const [newVideoUrl, setNewVideoUrl] = useState('');

  useEffect(() => {
    const fetchLatestVideoFromAPI = async () => {
      try {
        const latestUrl = await getLatestLiveVideo();
        if (latestUrl) {
          setVideoUrl(latestUrl);
          // Optional: Update Firestore so other users get it fast
          const videoDocRef = doc(collection(db, "videos"), "video1");
          await setDoc(videoDocRef, { videoUrl: latestUrl }, { merge: true });
        }
      } catch (error) {
        console.error("Error fetching live video from YouTube:", error);
      }
    };

    const fetchDataFromFirestore = async () => {
      try {
        const videoDocRef = doc(collection(db, "videos"), "video1");
        const videoDocSnap = await getDoc(videoDocRef);

        if (videoDocSnap.exists()) {
          setVideoUrl(videoDocSnap.data().videoUrl);
        } else {
          // If no Firestore data, try API immediately
          fetchLatestVideoFromAPI();
        }
      } catch (error) {
        console.error("Error fetching data from Firestore:", error);
        fetchLatestVideoFromAPI();
      }
    };

    fetchDataFromFirestore();
    // Also periodically check or just check once on mount
    fetchLatestVideoFromAPI();
  }, []);

  const handleSubmit = async () => {
    try {
      if (newVideoUrl) {
        const formattedUrl = getEmbedUrl(newVideoUrl);
        if (!formattedUrl) {
          alert("Invalid YouTube URL");
          return;
        }

        const videoDocRef = doc(collection(db, "videos"), "video1");
        const docSnap = await getDoc(videoDocRef);

        if (docSnap.exists()) {
          await updateDoc(videoDocRef, { videoUrl: formattedUrl });
        } else {
          await setDoc(videoDocRef, { videoUrl: formattedUrl });
        }

        setVideoUrl(formattedUrl);
        setNewVideoUrl('');
      }
    } catch (error) {
      console.error("Error updating Firestore:", error);
    }
  };

  return (
    <div className="video-img-container">
      <div className="live-banner">
        <h2 className="live-heading" data-aos="fade-in"><span className="live-dot"></span>Our Live Event</h2>
        <div className="live-animation"></div>
      </div>

      <div className="banner-container">
        <div className="video-section fade-up">
          {videoUrl && (
            <div className="video-wrapper" data-aos="zoom-in">
              <iframe
                src={videoUrl}
                title="Live Video"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          )}
          {isLoggedIn && (
            <div className="input-wrapper">
              <input
                type="text"
                placeholder="New Video URL"
                value={newVideoUrl}
                onChange={(e) => setNewVideoUrl(e.target.value)}
              />
              <button onClick={handleSubmit}>Update Video</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoImg;
